<template>
  <div class="wrap">
    <loading />
    <!-- <div v-if="!normalListData&&!hotListData" style="height:600px;"> -->
    <div v-if="currentFilterValue=='计量'&&showTable=='服务能力'">
      <div class="list-head">{{currentFilterValue}}</div>
      <table>
        <tr>
          <th>机构名称</th>
          <th>被测（参量/仪器/物质）</th>
          <th>校准类别/校准参量</th>
          <th>测量仪器型号/校准方法</th>
          <th>扩展不确定度</th>
          <th>测量环境/影响量</th>
          <th>测量等级</th>
        </tr>
        <tr v-for="item in normalListData" :key="item.id">
          <td  v-if="item.organName&&item.organName!=='null'">{{item.organName}}</td>
          <td  v-if="item.measureObject&&item.organName!=='null'">{{item.measureObject}}</td>
          <td  v-if="item.calibrationType&&item.calibrationType!=='null'">{{item.calibrationType}}</td>
          <td  v-if="item.calibrationType&&item.calibrationType!=='null'">{{item.measureModel }}</td>
          <td>
            <div v-if="item.expandedUncertaintyValue&&item.expandedUncertaintyValue!=='null'">数值:{{item.expandedUncertaintyValue}}</div>
            <div v-if="item.expandedUncertaintyUnit&&item.expandedUncertaintyUnit!=='null'">单位:{{item.expandedUncertaintyUnit}}</div>
            <div v-if="item.expandedUncertaintyK&&item.expandedUncertaintyK!=='null'">k:{{item.expandedUncertaintyK}}</div>
            <div v-if="item.expandedUncertaintyProbability&&item.expandedUncertaintyProbability!=='null'">置信概率:{{item.expandedUncertaintyProbability}}</div>
            <div v-if="item.expandedUncertaintyIsurel&&item.expandedUncertaintyIsurel!=='null'">是否为Urel:{{item.expandedUncertaintyIsurel}}</div>
          </td>
          <td>
            <div v-if="item.measureEnviromentParam&&item.measureEnviromentParam!=='null'">参量:{{item.measureEnviromentParam}}</div>
            <div v-if="item.measureEnviromentIndex&&item.measureEnviromentIndex!=='null'">指标:{{item.measureEnviromentIndex}}</div>
          </td>
          <td>
            <div v-if="item.measureLevelMin&&item.measureLevelMin!=='null'">最小:{{item.measureLevelMin}}</div>
            <div v-if="item.measureLevelMax&&item.measureLevelMax!=='null'">最大:{{item.measureLevelMax}}</div>
            <div v-if="item.measureLevelUnit&&item.measureLevelUnit!=='null'">单位:{{item.measureLevelUnit}}</div>
          </td>
        </tr>
      </table>
    </div>
    <div v-if="currentFilterValue=='计量'&&showTable!=='服务能力'">
      <div class="list-head">{{currentFilterValue}}
         <div class="tip-content">
                <span>
                  提示：共
                  <span style="color:#FC787B">{{normalListDataPage.totalCount}}</span>
                  条记录，本页显示{{normalListData.length}}条记录
                </span>
              </div>
      </div>
      <div class="list-content">
        <div class="organization" v-for="item in normalListData" :key="item.id">
          <div class="user-img" :style="item.color">{{item.name.split('')[0]}}</div>
          <div class="organization-left" @click="goDetail(item.id)">
            <span
              style="display:inline-block;padding-right:12px;"
              class="organization-head"
            >{{'['+item.name+']'}}</span>
            <span
              style="padding:1px 10px;border-radius:4px; border:1px solid #C0C0FF;font-size:12px;color:#C0C0FF"
            >{{item.level}}</span>
            <span class="organization-word">
              <span class="span-item-m">联系方式：{{item.phone}}</span>
              <span>邮　　编：{{item.email}}</span>
            </span>
            <span class="organization-word">
              <span>地　　址：{{item.address}}</span>
            </span>
          </div>
          <div class="organization-right">
            <div v-show="true" class="organization-button" @click="openUrl(item.webUrl)">访问官网</div>
            <div v-show="false" class="organization-button">下载</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentFilterValue=='标准'">
      <div class="list-head">{{currentFilterValue}}
        <div class="tip-content">
                <span>
                  提示：共
                  <span style="color:#FC787B">{{normalListDataPage.totalCount}}</span>
                  条记录，本页显示{{normalListData.length}}条记录
                </span>
              </div>
      </div>
      <div class="organization" v-for="item in normalListData" :key="item.id">
        <div class="organization-left-sta" @click="goDetail(item.id)">
          <span class="organization-head-sta">
            {{'['+item.name+']'}}
            <div
              v-if="item.category"
              :class="item.category==='国家标准'?'item-status-p':'item-status-p active-b'"
            >{{item.category}}</div>
            <div
              v-if="item.state"
              :class="item.state==='现行有效'?'item-status-g':'item-status-g active-r'"
            >{{item.state}}</div>
          </span>
          <span class="organization-word-sta">
            <!-- <span class="span-item-sta">行业类型：{{item.trade}}</span> -->
            <span class="span-item-sta">实施时间：{{item.workTime}}</span>
            <span class="span-item-sta">发布时间：{{item.pubTime}}</span>
          </span>
          <span class="organization-word-sta">发布单位：{{item.pubUnit}}</span>
        </div>
        <div class="organization-right">
          <div v-show="false" class="organization-button" @click="openUrl(item.webUrl)">访问官网</div>
          <div
            v-if="item.downloadUrl"
            class="organization-button"
            @click="downUrl(item.downloadUrl)"
          >下载</div>
          <div v-else class="organization-button">无法下载</div>
        </div>
      </div>
    </div>
    <div v-if="currentFilterValue=='认证认可'">
      <div class="list-head">{{currentFilterValue}}
        <div class="tip-content">
                <span>
                  提示：共
                  <span style="color:#FC787B">{{normalListDataPage.totalCount}}</span>
                  条记录，本页显示{{normalListData.length}}条记录
                </span>
              </div>
      </div>
      <div class="list-content">
        <div class="organization" v-for="item in normalListData" :key="item.id">
          <div class="user-img" :style="item.color">{{item.name.split('')[0]}}</div>
          <div class="organization-left" @click="goDetail(item.id)">
            <span class="organization-head">{{'['+item.name+']'}}</span>
            <span class="organization-word">
              <span style="width:25%;display:inline-block" class="span-item">机构批准号：{{item.approvalNumber }}</span>
              <span class="span-item">邮　　　编：{{item.postalCode}}</span>
            </span>
            <span class="organization-word">
              <span style="width:25%;display:inline-block" class="span-item">法定代表人：{{item.legalPerson}}</span>
              <span>法人注册号：{{item.legalRegistNumber }}</span>
            </span>
            <span class="organization-word">
              <span>地　　　址：{{item.address}}</span>
            </span>
          </div>
          <div class="organization-right">
            <div v-show="true" class="organization-button" @click="openUrl(item.webUrl)">访问官网</div>
            <div v-show="false" class="organization-button">下载</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentFilterValue=='检验检测'">
      <div class="list-head">{{currentFilterValue}}
        <div class="tip-content">
                <span>
                  提示：共
                  <span style="color:#FC787B">{{normalListDataPage.totalCount}}</span>
                  条记录，本页显示{{normalListData.length}}条记录
                </span>
              </div>
      </div>
      <div class="list-content">
        <div class="organization" v-for="item in normalListData" :key="item.id">
          <div class="user-img" :style="item.color">{{item.name.split('')[0]}} {{item.color}}</div>
          <div class="organization-left" @click="goDetail(item.id)">
            <span class="organization-head">
              {{'['+item.name+']'}}
              <div
                :class="item.cerState==='有效'?'item-status':'item-status active'"
              >{{item.cerState}}</div>
            </span>
            <span class="organization-word">
              <span class="span-item-ins-head">证书编号：{{item.cerNumber}}</span>
              <span class="span-item-ins-middle">所属系统：{{item.ownSystem}}</span>
              <span class="span-item-ins">发放日期：{{item.issueDate}}</span>
            </span>
            <span class="organization-word">
              <span class="span-item-ins-head">发证机关：{{item.licenceOrg}}</span>
              <span class="span-item-ins-middle">联系人：{{item.contact}}</span>
              <span class="span-item-ins">联系方式：{{item.phone}}</span>
            </span>
            <span class="organization-word">
              <span>地　　址：{{item.address}}</span>
            </span>
          </div>
          <div class="organization-right">
            <div v-show="true" class="organization-button" @click="openUrl(item.webUrl)">访问官网</div>
            <div v-show="false" class="organization-button">下载</div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="currentFilterValue=='行政法规'||currentFilterValue=='部门规章'||currentFilterValue=='行业规范'"
    >
      <div class="list-head">{{currentFilterValue}}
        <div class="tip-content">
                <span>
                  提示：共
                  <span style="color:#FC787B">{{normalListDataPage.totalCount}}</span>
                  条记录，本页显示{{hotListData.length}}条记录
                </span>
              </div>
      </div>
      <div style="min-height:70px" class="organization" v-for="item in hotListData" :key="item.id">
        <div class="organizations-left">
          <ul>
            <li>
              <span class="organization-head">{{'['+item.name+']'}}</span>
            </li>
          </ul>
        </div>
        <div class="organization-right">
          <div class="organization-button" @click="openUrl(item.webUrl)">查看</div>
          <div v-show="false" class="organization-button" @click="downUrl(item.downloadUrl)">查看</div>
        </div>
      </div>
    </div>
    <div v-if="currentFilterValue=='CNAS机构'">
      <div class="list-head">{{currentFilterValue}}</div>
      <div class="list-content">
        <div class="organization" v-for="item in hotListData" :key="item.id">
          <div class="user-img" :style="item.color">{{item.organName.split('')[0]}}</div>
          <div class="organization-left" @click="goDetail(item.id)">
            <span style="padding-bottom: 10px;" class="organization-head">
              {{'['+item.organName+']'}}
              <!-- <div
                :class="item.cerState==='有效'?'item-status':'item-status active'"
              >{{item.cerState}}</div>-->
            </span>
            <span class="organization-word">
              <span class="span-item-ins-head">证书编号：{{item.certificateNumber}}</span>
              <span style="width: 21%;" class="span-item-ins-middle">首次发证时间：{{item.firstCertificateTime}}</span>
              <span class="span-item-ins-foot">批准时间：{{item.approvalTime}}</span>
              <span class="span-item-ins">有效时间：{{item.userfulTime}}</span>
            </span>
            <span class="organization-word">
              <span class="span-item-ins-head">业务领域：{{item.field}}</span>
              <span  style="width: 21%;" class="span-item-ins-middle">联系人：{{item.contactPerson}}</span>
              <span class="span-item-ins-foot">联系电话：{{item.phone}}</span>
              <span class="span-item-ins">邮　　编：{{item.postcode}}</span>
            </span>
            <span class="organization-word">
              <span>地　　址：{{item.address}}</span>
            </span>
          </div>
          <div class="organization-right">
            <div v-show="false" class="organization-button">访问官网</div>
            <div v-show="true" class="organization-button" @click="openUrl(item.downloadUrl)">下载</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="currentFilterValue=='CMA机构'">
      <div class="list-head">{{currentFilterValue}}</div>
      <div class="list-content">
        <div class="organization" v-for="item in hotListData" :key="item.id">
          <div class="user-img" :style="item.color">{{item.organName.split('')[0]}}</div>
          <div class="organization-left" @click="goDetail(item.id)">
            <span style="padding-bottom: 7px;" class="organization-head">
              {{'['+item.organName+']'}}
              <!-- <div
                :class="item.cerState==='有效'?'item-status':'item-status active'"
              >{{item.cerState}}</div>-->
            </span>
            <span class="organization-word">
              <span class="span-item-ins-head">证书编号：{{item.certificateNumber}}</span>
              <span class="span-item-ins-middle">所属系统：{{item.systemType}}</span>
              <span class="span-item-ins-foot">省　　份：{{item.province}}</span>
              <span class="span-item-ins">有效时间：{{item.userfulTime}}</span>
            </span>
            <span class="organization-word">
              <span class="span-item-ins-head">联系人：{{item.contactPerson }}</span>
              <span class="span-item-ins-middle">联系电话：{{item.contactPersonPhone}}</span>
              <span class="span-item-ins">联系邮箱：{{item.legalPersonEmail}}</span>
            </span>
            <span class="organization-word">
              <span class="span-item-ins-head">批准时间：{{item.approvalTime}}</span>
              <span>地　　址：{{item.address}}</span>
            </span>
          </div>
          <div class="organization-right">
            <!-- <div v-show="false" class="organization-button">访问官网</div>
            <div v-show="true" class="organization-button"  @click="openUrl(item.downloadUrl)">下载</div>-->
          </div>
        </div>
      </div>
    </div>
     <div
      v-if="currentFilterValue=='新闻动态'"
    >
      <div class="list-head">{{currentFilterValue}}
        <div class="tip-content">
                <span>
                  提示：共
                  <span style="color:#FC787B">{{normalListDataPage.totalCount}}</span>
                  条记录，本页显示{{hotListData.length}}条记录
                </span>
              </div>
      </div>
      <div style="min-height:70px" class="organization" v-for="item in hotListData" :key="item.id">
        <div class="organizations-left">
          <ul>
            <li>
              <span class="organization-head">{{'['+item.title+']'}}</span>
            </li>
          </ul>
        </div>
        <div class="organization-right">
          <div class="organization-button" @click="pushNewsDetail(item.id)">查看</div>
          <div v-show="false" class="organization-button" @click="downUrl(item.downloadUrl)">查看</div>
        </div>
      </div>
    </div>
     <div
      v-if="currentFilterValue=='法律'||currentFilterValue=='法规'"
    >
      <div class="list-head">{{currentFilterValue}}
        <div class="tip-content">
                <span>
                  提示：共
                  <span style="color:#FC787B">{{normalListDataPage.totalCount}}</span>
                  条记录，本页显示{{normalListData.length}}条记录
                </span>
              </div>
      </div>
      <div style="min-height:70px" class="organization" v-for="item in normalListData" :key="item.id">
        <div class="organizations-left">
          <ul>
            <li>
              <span class="organization-head">{{'['+item.name+']'}}</span>
            </li>
          </ul>
        </div>
        <div class="organization-right">
          <div class="organization-button" @click="openUrl(item.webUrl)">查看</div>
          <div v-show="false" class="organization-button" @click="downUrl(item.downloadUrl)">查看</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loading from '@/components/loading';
export default {
  name: 'normalList',
  components: {
    loading
  },
  props: {
    // normalListData: Array,
    currentFilterValue: String
  },
  created () {},
  mounted () {},
  data () {
    return {};
  },
  watch: {
    normalListData (val) {
      val.forEach(element => {
        if (element.name) {
          element.color = this.tranColor(element.name);
        }
      });
    },
    hotListData (val) {
      val.forEach(element => {
        if (element.organName) {
          element.color = this.tranColor(element.organName);
        }
      });
    }
  },
  computed: {
    normalListData: function () {
      return this.$store.state.normalListData;
    },
    normalListDataPage () {
      return this.$store.state.normalListDataPage;
    },
    hotListData: function () {
      return this.$store.state.hotListData;
    },
    showTable () {
      return this.$store.state.activeShow
    }
  },
  methods: {
    pushNewsDetail (id) {
      this.$router.push({path: '/newsDetail?id=' + id})
    },
    particulArs () {
      this.$router.push({ path: '/metroloyDetail' });
    },
    tranColor (name) {
      var str = '';
      for (var i = 0; i < name.length; i++) {
        str += parseInt(name[i].charCodeAt(0), 10).toString(16);
      }
      return 'background:' + '#' + str.slice(1, 4);
    },
    goDetail (id) {
      if (!window.getSelection().toString()) {
        window.localStorage.setItem('id', id);
        // this.$store.commit('saveId', id)、
        let routeData = {}
        switch (this.currentFilterValue) {
          case '计量':
            routeData = this.$router.resolve({ path: '/metroloyDetail' });
            break;
          case '标准':
            routeData = this.$router.resolve({ path: '/standardDetail' });
            break;
          case '认证认可':
            routeData = this.$router.resolve({ path: '/certificationDetail' });
            break;
          case '检验检测':
            routeData = this.$router.resolve({ path: '/testDetail' });
            break;
          case 'CNAS机构':
            routeData = this.$router.push({ path: '/cnasDetail' });
            break;
          case 'CMA机构':
            routeData = this.$router.resolve({ path: '/cmaDetail' });
            break;
          default:
            break;
        }
        window.open(routeData.href, '_blank');
      }
    },
    openUrl (url) {
      setTimeout(() => {
        window.open(url);
      }, 1);
    },
    downUrl (url) {
      if (url) {
        setTimeout(() => {
          window.open(url);
        }, 1);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.wrap {
  width: @body-width;
  min-height: 200px;
  table {
    border-collapse: collapse;
    margin: 0 auto;
    margin-top: 10px;
    text-align: center;
    width:1200px;
  }
  table td, table th {
    border: 1px solid #cad9ea;
    color: #666;
    height: 30px;
    text-align: center;
    padding: 1px;
  }
  table thead th {
    background-color: #cce8eb;
    width: 100px;
  }
  table tr:nth-child(odd) {
    background: #fff;
  }
  table tr:nth-child(even) {
    background: #f5fafa;
  }
  .list-head {
    border-left: 4px solid @color-base;
    border-bottom: 1px solid rgba(@color-base, 0.2);
    width: @body-width;
    height: 60px;
    background: #c8e4ff;
    line-height: 60px;
    font-size: 24px;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    padding:0 30px;
    display: flex;
    justify-content: space-between;
   .tip-content {
     height: 60px;
     line-height: 60px;
          span {
            font-size: 14px;
            padding: 0;
          }
    }
  }
  .list-content {
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
    .list-item:hover {
      box-shadow: 0 6px 10px 0 rgba(0, 141, 255, 0.1);
      border: 1px solid rgba(0, 141, 255, 0.1);
    }
    .list-item {
      height: 62px;
      background: rgba(255, 255, 255, 1);
      line-height: 62px;
      margin-bottom: 8px;
      cursor: pointer;
      // .gray-item {
      //   color: @color-gray;
      // }
      // .blue-item {
      //   color: @color-blue;
      // }
      // .black-item {
      //   color: @color-black;
      // }
    }
  }
  .more {
    height: 22px;
    font-size: 16px;
    font-weight: 400;
    color: @color-blue;
    line-height: 22px;
    text-align: center;
    padding-top: 12px;
    cursor: pointer;
  }
  .organization:hover {
    box-shadow: 0 6px 10px 0 rgba(0, 141, 255, 0.1);
    border: 1px solid rgba(0, 141, 255, 0.1);
  }
  .organization {
    margin-top: 8px;
    width: @body-width;
    min-height: 154px;
    background: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    padding: 0 30px;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, .1);
    .user-img {
      width: 80px;
      height: 80px;
      font-size: 32px;
      line-height: 80px;
      color: white;
      text-align: center;
    }
    .organizations-left {
      width: 90%;
      /*height: 154px;*/
      ul li:before {
        content: "\2022"; //圆点
        color: rgba(0, 0, 0, 0.25); //颜色
        font-size: 16px;
        padding-right: 8px; //大小
      }
      // ul li{
      //   list-style: disc;
      //   color: rgba(0,0,0,0.25);
      // }
      .organization-head {
        display: inline-block;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        /*padding-top: 24px;*/
        padding-bottom: 12px;
        .item-status {
          margin-left: 5px;
          display: inline-block;
          // width: 60px;
          height: 20px;
          border-radius: 2px;
          background: hsla(120, 100%, 36%, 1);
          opacity: 0.85;
          text-align: center;
          font-size: 12px;
          color: white;
          // line-height: 20px;
          font-weight: 500;
        }
        .active {
          background: hsla(357, 91%, 55%, 1);
        }
      }
      .organization-word {
        // .span-item-top {
        //   padding-right: 82px;
        // }
        .span-item {
          padding-right: 20px;
        }
        .span-item-m {
          display: inline-block;
          width: 200px;
        }
        .span-item-ins-head {
          display: inline-block;
          width: 35%;
        }
        .span-item-ins-middle {
          display: inline-block;
          width: 18%;
        }
        .span-item-ins-foot {
          display: inline-block;
          width: 22%;
        }
        .span-item-ins {
          padding-right: 60px;
        }
        padding-left: 24px;
        padding-bottom: 6px;
        display: block;
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
      }
    }
    .organization-left {
      width: 90%;
      /*height: 154px;*/
      .organization-head {
        display: block;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        /*padding-top: 24px;*/
        padding-bottom: 12px;
        padding-left: 24px;
        .item-status {
          margin-left: 5px;
          display: inline-block;
          // width: 60px;
          height: 20px;
          border-radius: 2px;
          background: hsla(120, 100%, 36%, 1);
          opacity: 0.85;
          text-align: center;
          font-size: 12px;
          color: white;
          padding: 0 10px;
          line-height: 20px;
          font-weight: 500;
        }
        .active {
          background: hsla(357, 91%, 55%, 1);
        }
      }
      .organization-word {
        // .span-item-top {
        //   padding-right: 82px;
        // }
        .span-item {
          padding-right: 20px;
        }
        .span-item-m {
          display: inline-block;
          width: 200px;
        }
        .span-item-ins-head {
          display: inline-block;
          width: 35%;
        }
        .span-item-ins-middle {
          display: inline-block;
          width: 18%;
        }
        .span-item-ins-foot {
          display: inline-block;
          width: 22%;
        }
        .span-item-ins {
          padding-right: 60px;
        }
        padding-left: 24px;
        padding-bottom: 6px;
        display: block;
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
      }
    }
    .organization-left-sta {
      width: 90%;
      // height: 154px;
      .organization-head-sta {
        display: block;
        font-size: 16px;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
        padding-bottom: 12px;
        .item-status-p {
          margin-left: 5px;
          display: inline-block;
          // width: 60px;
          padding: 1px 16px;
          height: 20px;
          border-radius: 2px;
          background: #bd51c5;
          opacity: 0.85;
          text-align: center;
          font-size: 12px;
          color: white;
          line-height: 20px;
          font-weight: 500;
        }
        .active-b {
          background: #6aa9ff;
        }
        .item-status-g {
          margin-left: 5px;
          display: inline-block;
          // width: 60px;
          padding: 1px 16px;
          height: 20px;
          border-radius: 2px;
          background: #00b900;
          opacity: 0.85;
          text-align: center;
          font-size: 12px;
          color: white;
          line-height: 20px;
          font-weight: 500;
        }
        // .active-p {
        //   background: #f5222d;
        // }
        .active-r {
          background: #f5222d;
        }
      }
      .organization-word-sta {
        // .span-item-top {
        //   padding-right: 82px;
        // }
        .span-item-sta {
          padding-right: 78px;
        }
        // padding-left: 24px;
        padding-bottom: 6px;
        display: block;
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
      }
    }
    .organization-right {
      .organization-button {
        width: 88px;
        line-height: 28px;
        border-radius: 2px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        font-size: 12px;
        text-align: center;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.65);
      }
      .organization-button:hover {
        border: 1px solid rgba(0, 141, 255, 1);
        color: rgba(0, 141, 255, 1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/normalList.vue